export default "__VITE_ASSET__u83gvuC2__"